
import Frame from "../../../assets/filled/Frame.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FrameIcon({ className, dataTestid = "FrameIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Frame data-testid={dataTestid} className={classes} {...rest} />
  );
}
